import {T} from '../../utils/I18n/I18n';
import {useTranslation} from "react-i18next";
import React, {forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {useCartContext} from '../../context/CartContext';
import {useUserContext} from '../../context/UserContext';
import useCartMutation from '../../hooks/useCartMutation';
import {UPDATE_PICKUP_STORE} from '../../queries/cart';
import {STORE_LOCATIONS} from '../../queries/misc';
import {METHOD_STORE} from '../../utils/checkout';
import {addShippingInfoEvent} from '../../hooks/useAnalytics';
import CheckoutEmailOrLogin from './CheckoutEmailOrLogin';
import CheckoutFormField from './CheckoutFormField';
import CheckoutShippingOptions from './CheckoutShippingOptions';

const CheckoutStorePickupForm = forwardRef(({ setIsDisabled, storeLocations }, ref) => {

  const { cart } = useCartContext();

  const [email, setEmail] = useState(cart.email);

  const [updatePickupStore] = useCartMutation(UPDATE_PICKUP_STORE);

  const { t } = useTranslation();
  const { user } = useUserContext();
  console.log('storeLocations',storeLocations)

  const shippingAddress = cart && cart.shipping_addresses && cart.shipping_addresses[0];
  const shippingMethod = shippingAddress && shippingAddress.selected_shipping_method;
  const isStorePickup = shippingMethod && shippingMethod.carrier_code === METHOD_STORE;

  const [selectedLocation, setSelectedLocation] = useState();

  const formRef = useRef();

  const getField = field => {
    return formRef.current.elements.namedItem(field);
  };
  const onChangeHandler = event => {
    const selected =
      storeLocations.find(location => {
        return location.storepickupId === event.target.value;
      });

    setSelectedLocation(selected);
  };

  useEffect(() => {
    setIsDisabled(false);
    addShippingInfoEvent(cart.items, 'Click&Collect')
  }, []);

  useEffect(() => {
    if (isStorePickup) {
      const selected =
        storeLocations.find(location => {
          return location.city === cart.shipping_addresses[0].city;
        });

      setSelectedLocation(selected);
      getField('location').value = selected ? selected.storepickupId : undefined;
      if ('email' in formRef.current.elements) {
        getField('email').value = cart.email;
      }
    }
  }, [cart]);

  useImperativeHandle(
    ref,
    () => ({
      submit: () => {
        if (formRef.current.reportValidity()) {
          return updatePickupStore({
            variables: {
              pickupStore: selectedLocation.storepickupId,
              telephone: '1234',
              email: user ? user.email : getField('email').value,
            },
          });
        }

        return Promise.reject();
      },
    }),
    [user, selectedLocation],
  );
  return (
    <form ref={formRef}>
      {!user && <CheckoutEmailOrLogin email={email} setEmail={setEmail}/>}

      <CheckoutFormField
        required
        label={t('cartSummary.chooseStoreLocation')}
        id="location"
        defaultValue={selectedLocation && selectedLocation.storepickupId}
        onChange={onChangeHandler}
      >
        <option value="">{t('checkout.storeLocation')}</option>

        {storeLocations.map(location => (
            <option key={location.city} value={location.storepickupId}>
              {location.city}
            </option>
          ))}
      </CheckoutFormField>

      {selectedLocation && (
        <div className="location-details">
          <p>{selectedLocation.storeName}</p>
          <p>{selectedLocation.address}</p>
          <p>
            {selectedLocation.city}, {selectedLocation.state} {selectedLocation.zipcode}
          </p>
          <p>{selectedLocation.country}</p>
          <p>{selectedLocation.phoneNumber}</p>
          <p>
            <T id="checkout.workingHours" />: {selectedLocation.workingHours}
          </p>
          {selectedLocation.additionalInformation && <div className={'description'} dangerouslySetInnerHTML={{__html: selectedLocation.additionalInformation}} />}
        </div>
      )}

      {selectedLocation && <CheckoutShippingOptions carrierCode={METHOD_STORE} isChecked />}
    </form>
  );
});

export default CheckoutStorePickupForm;
